// ============================================================
// THE COMPANY — Constants
// ============================================================

import type { RoleStatus } from './types';

/** Company name used across prompts and UI */
export const COMPANY_NAME = 'THE COMPANY';

/** Status dot / badge colors (from design.json) */
export const STATUS_COLORS: Record<RoleStatus, string> = {
  idle: '#6b7280',
  waiting: '#f59e0b',
  active: '#22c55e',
  blocked: '#ef4444',
  done: '#3b82f6',
};

/** Human-readable status labels */
export const STATUS_LABELS: Record<RoleStatus, string> = {
  idle: 'Idle',
  waiting: 'Waiting',
  active: 'Active',
  blocked: 'Blocked',
  done: 'Done',
};

/** Ordered list of all status values (useful for dropdowns / filters) */
export const DEFAULT_STATUSES: RoleStatus[] = [
  'idle',
  'waiting',
  'active',
  'blocked',
  'done',
];
